export default __webpack_public_path__ + "static/media/r3.7cd76ec5.jpeg";